<template>
  <div class="bgf4">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <div class="layout">
        <div v-if="isVideo">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"  :options="playerOptions"
          @play="onPlayerPlay($event)"
          style="width:600px">
          </video-player>
        </div>
        <div class="right">
          <span class="h1" :title="data.traintitle">
            {{data.traintitle}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a-button @click="downloadFile" type="link">下载</a-button>
          </span>
          <div class="bottom">
            <a-row>
              <a-col style="padding:20px;margin-top:30px">作者：{{data.author}}</a-col>
              <a-col style="padding:20px">发布日期：{{data.publishdate}}</a-col>
              <a-col style="padding:20px">已学习：<span style="color:red">{{data.studynum}}</span>次</a-col>
            </a-row>
            <!-- <span class="author">作者：{{data.author}}</span>
            <span class="date">发布日期：{{data.publishdate}}</span>
            <span class="stu">已学习：<span style="color:red">{{data.studynum}}</span>次</span> -->
          </div>
          <div v-if="!isPdfOrVideo" style="padding:20px;color: red;">
            本文件不支持在线预览，请下载后查看。
          </div>
        </div>
      </div>
      <div class="read-file-div" style="height: 670px;" v-if="!isVideo">
        <!--<pdf
          ref="readPdf"
          v-for="i in numPages"
          :key="i"
          :src="pdfSrc"
          :page="i"
        ></pdf>-->
        <iframe width="100%" height="100%" scrolling="no" :src="pdfSrc"></iframe>
      </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { videoPlayer } from "vue-video-player"
import pdf from "vue-pdf";
import "video.js/dist/video-js.css";
export default {
  name: 'App',
  components: {
    videoPlayer,
    pdf
  },
  data(){
    return{
      pdfSrc: '',
      numPages: null, // pdf 总页数
      isVideo: null,
      downloadUrl: '',
      isPdfOrVideo: null,
      fileUrl: '',
      disabled:false,
      playerOptions: {

        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度

        autoplay: false, //如果true,浏览器准备好时开始回放。

        muted: false, // 默认情况下将会消除任何音频。

        loop: false, // 导致视频一结束就重新开始。

        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）

        language: "zh-CN",

        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）

        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

        sources: [

        {

        type: "video/mp4",

        src: '',
        //视频url地址

        },

        ],

        poster: '', //你的封面地址

        // width: '100%',

        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。

        controlBar: {

        timeDivider: true,

        durationDisplay: true,

        remainingTimeDisplay: false,

        fullscreenToggle: true, //全屏按钮
        },},
      locale: zhCN,

      image:'',
      data:{}
    }
  },
  computed:{

  },
  created(){
    this.image = http.imageURL
    this.queryDetial(this.$route.query.id)
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    //计算pdf页码总数
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdfSrc)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    onPlayerPlay(){
      var arr = document.cookie.split('; ');
      if(arr.length>1){
        this.$refs.videoPlayer.player.play()
      }else{
        this.$refs.videoPlayer.player.pause()
        this.$message.warning("您尚未登录，请登录后再试！")
      }
    },
    queryDetial(value){
      http.get('/queryDetial',{params:{id:value}}
      ).then((res) => {
        this.data = res.data.result;
        this.data.studynum = parseInt(this.data.studynum);
        let videocontent = this.data.videocontent;
        let suffix =videocontent.substring(videocontent.lastIndexOf(".")+1);
        let downloadUrl = this.image+this.data.videocontent;
        this.downloadUrl = downloadUrl;
        if(suffix !== 'mp4' && suffix !== '3gp' && suffix !== 'mov' && suffix !== 'm4v'
            && suffix !== 'avi' && suffix !== 'mkv' && suffix !== 'flv' && suffix !== 'vob') {
          this.isVideo = false;
          if(suffix === 'pdf') {
            this.isPdfOrVideo = true;
            //this.pdfSrc = "/pdfjs/web/viewer.html?file=" + downloadUrl;
            let urlfile=encodeURIComponent(downloadUrl)
            this.pdfSrc = "static/pdfjs/web/viewer3.html?file="+urlfile;
          } else {//不是pdf
            this.isPdfOrVideo = false;
            //window.open(downloadUrl, "_self");
          }
          //this.getNumPages()
        } else {
          this.isPdfOrVideo = true;
          this.isVideo = true;
          this.playerOptions.sources[0].src=this.image+this.data.videocontent;
          this.playerOptions.poster = this.image+this.data.coverimage;
        }
      })
    },
    downloadFile() {
      window.open(this.downloadUrl, '_self');
    },
  },
}
</script>


<style scoped>
  @import "../../config/AquaticTrainDetial.css";
</style>







// WEBPACK FOOTER //
// src/views/aquatictrain/AquaticTrainDetial.vue